import { $user } from "./store/user";
import { $permissions } from "./store/permissions/permissions";
import "./pusher";
// import "./centrifugo";
import { $bitrix } from "./store/bitrix";
import jwt_decode from "jwt-decode";
import axios from "./api/axios";

export const initRequests = async ({ throwOnError = false } = {}) => {
  const JWT = localStorage.getItem("jwtToken");

  if (!JWT) {
    $user.resetAuth();
    return;
  }

  try {
    axios.defaults.headers.common.Authorization = `Bearer ${
      jwt_decode(JWT).jti
    }`;
    axios.defaults.headers.common.JWT = JWT;

    $bitrix.checkAuth();
    await $permissions.initPermissions();
    $user.setIsAuthorized(true);
  } catch (err) {
    $user.resetAuth();
    if (throwOnError) {
      throw err;
    }
  } finally {
    $user.setIsAuthChecked(true);
  }
};

initRequests();
